'use client';
import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { cn } from '../lib/utils';
const Checkbox = React.forwardRef(({ className, ...props }, ref) => (React.createElement(CheckboxPrimitive.Root, { ref: ref, className: cn('peer h-8 w-8 shrink-0 rounded-[4px] border border-brand-navy ring-offset-black focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-brand-navy data-[state=checked]:text-white', className), ...props },
    React.createElement(CheckboxPrimitive.Indicator, { className: cn('flex items-center justify-center text-current') },
        React.createElement(Check, { className: "h-5 w-5" })))));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
export { Checkbox };
